import { AbstractControl, FormGroup, Validators } from '@angular/forms';
import { UtilsService } from '@shared/services/utils/utils.service';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { Subject } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { CommonService } from 'src/app/core/providers/forms/common.service';
import { CotizarService } from 'src/app/core/providers/services/cotizar/cotizar.service';
import { Numbers, TRAVELERS_TYPE } from 'src/app/utils/constants';
import FormsStepsUtils from '../forms-steps.utils';
import { SelectMultipleValueModel } from 'src/app/core/models/select-multiple.model';
import { QuotationReqModel } from 'src/app/core/models/cotizar.model';
import { Renderer2 } from '@angular/core';
import { DocumentsService } from 'src/app/core/providers/services/documents/documents.service';
import { ProductIdCorreduria } from 'src/app/core/interfaces/producto-informacion.interface';
export default class StudentsStepOne extends FormsStepsUtils {
  /**
   * constructor
   * @param gtmService gtmService
   * @param commons commons
   * @param utilsSrv utilsSrv
   * @param cotSrv cotSrv
   */
  constructor(gtmService: GoogleTagManagerService, commons: CommonService, utilsSrv: UtilsService,
              cotSrv: CotizarService, renderer: Renderer2) {
    super(utilsSrv);
    this.gtmService = gtmService;
    this.commons = commons;
    this.utilsSrv = utilsSrv;
    this.cotSrv = cotSrv;
    this.renderer = renderer;
  }
  readonly gtmService: GoogleTagManagerService;
  readonly commons: CommonService;
  readonly utilsSrv: UtilsService;
  readonly cotSrv: CotizarService;
  readonly renderer: Renderer2;
  public currentStep = 0;
  public showModal = false;
  public displayModal: boolean;
  public showModal2 = false;
  public displayModal2: boolean;
  public showModal3 = false;
  public displayModal3: boolean;
  public insureSelected: string;
  public sobreprimasList: any[];
  public formDataValue: any;
  public numberOfInsuredList: any; // Lista de apoyo a el numero de asegurados
  public yearsList: any; // Lista de apoyo a el numero de asegurados de 70 años
  public unitfamiliar = false; // Se asigna si es unidad familiar
  public showGuaranteeTable: boolean;
  public numberOfInsuredMax = 0;
  public numberOfInsuredChange = false;
  public errorNumberInsuredMax = false;
  public isOrigenSpain = true;
  public isOriginDestinySpain = false;
  public requireChangeV: boolean = null;
  public isInvalid = true;
  public maxDate: any;
  public numInsuredChange: { name: string, value: any };
  public guaranteeLimitOfMedicalChange: { name: string, value: any };
  public sportChange: { name: string, value: any };
  public countryChange: { name: string, value: any };
  public countryDChange: { name: string, value: any };
  public promotionChange: { name: string, value: any };
  public destinySpain: { name: string, value: any };
  public checkPromoS = false;
  public disabledDestiny = false;
  public disabledDestinySpain = false;
  public showStep1Fields = false;
  public isFieldO = true;
  public idProduct = 0;
  public documentsConst: any = {
    idProveedor: 1,
    idPortal: 1,
    productGeneral: 1,
    productIPId: Numbers.number8,
    productNota: Numbers.number9,
    generalName: 'condicionado_general',
    ipidName: 'document_ipid',
    notaName: 'document_nota'
  };
  public insuranceTime: any;
  public finish = new Subject();

  /**
   * @description asignar la cotización
   */
  callCotizar(formDataValue: any,
              formConfig: any,
              isOriginDestinySpain: boolean,
              isOrigenSpain: boolean,
              productosCorreduria: ProductIdCorreduria[]): void {
    const { firstOptBase, vencimientoDate}: any = this.setOptions(formDataValue, productosCorreduria);
    let expitarionDate: string = vencimientoDate;
    let secondOpt: any;
    let nextCoverage: string;

    const { firstOpt, firstOptBaseAnual, firstOptBaseAnualTemp, firstOptBase90 }: any =
      this.prepareTraveleres(firstOptBase, formDataValue);

    if (firstOpt.tipocobertura === 'Anual_+90') {
      nextCoverage = 'Anual';
      expitarionDate = this.utilsSrv.changeDateOrderToServiceAnual(formDataValue.dateStart);
      secondOpt = {
        ...firstOptBaseAnual,
        fecvencimiento: expitarionDate,
        tipocobertura: nextCoverage
      };
    }
    if (firstOpt.tipocobertura === 'Anual') {
      nextCoverage = 'Anual_+90';
      expitarionDate = this.utilsSrv.changeDateOrderToServiceAnual(formDataValue.dateStart);
      secondOpt = {
        ...firstOptBase90,
        fecvencimiento: expitarionDate,
        tipocobertura: nextCoverage
      };
    }
    if (firstOpt.tipocobertura === 'Temporal') {
      nextCoverage = 'Anual';
      expitarionDate = this.utilsSrv.changeDateOrderToServiceAnual(formDataValue.dateStart);
      secondOpt = {
        ...firstOptBaseAnualTemp,
        fecvencimiento: expitarionDate,
        tipocobertura: nextCoverage
      };
    }
    let idx = 0;
    if (isOriginDestinySpain) {
      idx = Numbers.number2;
    } else {
      if (isOrigenSpain) {
        idx = Numbers.number1;
      }
    }
    formConfig.insuranceType.radioCardList[idx].price = '';
    this.cotSrv.postQuotation(firstOpt)
      .pipe(
        take(1),
        tap((resp: any) => {
          const precioTotal = 'Precio_Total';
          formConfig.insuranceType.radioCardList[idx].price = resp[precioTotal].toFixed(Numbers.number2);
          formConfig.insuranceType.radioCardList[idx].budge = resp;
        })
      ).subscribe();
  }

  /**
   * prepareTraveleres
   * @param firstOptBase firstOptBase
   * @param formDataValue formDataValue
   * @returns returns
   */
  prepareTraveleres(firstOptBase: any, formDataValue: any): Record<string, any> {
    const result: Record<string, any> = {};
    Object.entries(TRAVELERS_TYPE).forEach((key) => {
      result[key[0]] = {
        ...firstOptBase,
        viajeros: this.addTravelers(formDataValue, key[1])
      };
    });
    return result;
  }

  /**
   * datalayer
   * @param formName formName
   */
  datalayer(formName: any): void {
    const datalayerD: any = {
      event: 'ev_tarificacion',
      event_category: 'tarificacion',
      event_action: formName.layerName,
      event_label: 'gestion_de_polizas',
      categoria_seguro: 'viajes',
      paso: 't1'
    };
    this.gtmService.pushTag(datalayerD);
  }

  /**
   * datalayer2
   * @param nameDoc nameDoc
   */
  datalayer2(nameDoc: any): void {
    const datalayerD: any = {
      event: 'ev_descarga',
      event_category: 'descarga',
      event_action: nameDoc.split(' ').join('_'),
      event_label: '-'
    };
    this.gtmService.pushTag(datalayerD);
  }

  /**
   * setOptions
   * @param formDataValue formDataValue
   * @returns returns
   */
  setOptions(formDataValue: any, productosCorreduria: any[]): { firstOptBase: any, vencimientoDate: any } {
    const vencimientoDate: string = this.utilsSrv.changeDateOrderToService(formDataValue.dateEnd);
    let unidadFamiliar = '0';
    let descuentoMediador = '0';

    if (formDataValue.allInsuredSameFamiliarUnit) {
      unidadFamiliar = '1';
    }

    let garantias1: any[] = [];
    if (formDataValue.guaranteeSelectionList.length > 0) {
      garantias1 = formDataValue.guaranteeSelectionList;
    }

    if (!(productosCorreduria.length === 1 && productosCorreduria[0] === 0)) {
      descuentoMediador = productosCorreduria.filter(
        item => Number(item.producto) === formDataValue.guaranteeLimitOfMedicalExpenses.idProducto
      )[0].descuentoMediador.toString();
    }

    const firstOptBase: any = {
      idproducto: `${formDataValue.guaranteeLimitOfMedicalExpenses.idProducto}`,
      fecefecto: this.utilsSrv.changeDateOrderToService(formDataValue.dateStart),
      fectarificacion: this.utilsSrv.getDateToday(),
      procedencia: 'WEB',
      recargo: 0,
      descuentomediador: descuentoMediador,
      idportal: '1',
      unidadfamiliar: unidadFamiliar,
      desdescuento: formDataValue.codePromotional,
      tipocobertura: this.getCoverageType(formDataValue.insuranceDuration),
      garantias: garantias1,
      fecvencimiento: vencimientoDate,
      idProveedor: `${formDataValue.idCorreduria}`
    };
    return { firstOptBase, vencimientoDate };
  }

  /**
   * downloadFile
   * @param item item
   * @param name name
   */
  downloadFile(item: any, name?: string): void {
    let filename: string;
    filename = 'document';
    if (name !== '') {
      filename = name;
    }
    const linkElement: HTMLElement = this.renderer.createElement('a');
    this.renderer.setAttribute(linkElement, 'href', window.URL.createObjectURL(this.commons.b64toBlob(item, 'application/pdf')));
    this.renderer.setAttribute(linkElement, 'download', filename);
    linkElement.dispatchEvent(new MouseEvent('click', { view: window, bubbles: true, cancelable: false}));
    this.datalayer2(filename);
  }

  /**
   * showModalDialog2
   */
  showModalDialog2(): void {
    this.displayModal2 = true;
    this.showModal2 = this.displayModal2;
  }

  /**
   * validNumberOfInsuredUtils
   * @param formData formData
   */
  validNumberOfInsuredUtils(formData: FormGroup): void {
    let valNumberField2 = 0;
    if (formData.get([this.insureSelected, 'numberOfInsured']).value) {
      valNumberField2 = formData.get([this.insureSelected, 'numberOfInsured']).value.id;
    }
    let valYearsField2 = 0;
    if (formData.get([this.insureSelected, 'insuredOlderThan60years']).value) {
      valYearsField2 = formData.get([this.insureSelected, 'insuredOlderThan60years']).value.id;
    }
    this.errorNumberInsuredMax = false;
    if (valNumberField2 < valYearsField2) {
      this.errorNumberInsuredMax = true;
    }
    if (this.errorNumberInsuredMax) {
      this.showModalDialog2();
      this.sportChange = { name: 'sport-70', value: { name: '0', id: 0 } };
    }
  }

  /**
   * getLisIniGuaranteeLimitOfMedicalExpensesUtils
   * @param formConfig formConfig
   * @param formData formData
   */
  getLisIniGuaranteeLimitOfMedicalExpensesUtils(formConfig: any, formData: FormGroup): void {
    if (this.isOriginDestinySpain) {
      formConfig.guaranteeLimitOfMedicalExpenses.options.list =
      formData.get([this.insureSelected, 'guaranteeNational']).value;
      formData.get([this.insureSelected, 'typeStudent']).setValue('nacional');
    } else if (!this.isOrigenSpain) {
      formConfig.guaranteeLimitOfMedicalExpenses.options.list =
      formData.get([this.insureSelected, 'guaranteeIncoming']).value;
    } else {
      formConfig.guaranteeLimitOfMedicalExpenses.options.list =
      formData.get(['incomingStudentsTravelAsistance', 'guaranteeOutgoing']).value;
    }
    this.guaranteeLimitOfMedicalChange = { name: 'guarantee', value: formConfig.guaranteeLimitOfMedicalExpenses.options.list };
  }

  /**
   * resetTableUtils
   * @param formData formData
   */
  resetTableUtils(formData: FormGroup): void {
    this.showGuaranteeTable = false;
    const resetTable: any = setTimeout(() => {
      const guarateeLimit: any = formData.get([this.insureSelected, 'guaranteeLimitOfMedicalExpenses']).value.name;
      // tslint:disable-next-line: radix
      const guarantee = parseInt(guarateeLimit, Numbers.number10);
      // tslint:disable-next-line: radix
      if (guarantee === Numbers.number18000) {
        this.showGuaranteeTable = false;
      } else {
        this.showGuaranteeTable = true;
      }
      clearTimeout(resetTable);
    }, Numbers.number20);
  }

  /**
   * setValidatorUtils
   * @param formData formData
   */
  public setValidatorUtils(formData: FormGroup): void {
    formData.get([this.insureSelected, 'numberOfInsured']).setValidators([Validators.required]);
    formData.get([this.insureSelected, 'guaranteeLimitOfMedicalExpenses']).setValidators([Validators.required]);
    formData.get([this.insureSelected, 'countryOrigin']).setValidators([Validators.required]);
    formData.get([this.insureSelected, 'dateStart']).setValidators([Validators.required]);
    formData.get([this.insureSelected, 'dateEnd']).setValidators([Validators.required]);
    if (this.insureSelected === 'sportTravelAsistance') {
      formData.get([this.insureSelected, 'sports']).setValidators([Validators.required]);
      formData.get([this.insureSelected, 'sports']).updateValueAndValidity();
    }
    formData.get([this.insureSelected, 'numberOfInsured']).updateValueAndValidity();
    formData.get([this.insureSelected, 'guaranteeLimitOfMedicalExpenses']).updateValueAndValidity();
    formData.get([this.insureSelected, 'countryOrigin']).updateValueAndValidity();
    formData.get([this.insureSelected, 'dateStart']).updateValueAndValidity();
    formData.get([this.insureSelected, 'dateEnd']).updateValueAndValidity();
  }

  /**
   * showModalDialog3
   */
  showModalDialog3(): void {
    this.displayModal3 = true;
    this.showModal3 = this.displayModal3;
  }

  /**
   * resetGuaranteeSelectionUtils
   * @param formData formData
   */
  resetGuaranteeSelectionUtils(formData: FormGroup): void {
    formData.get([this.insureSelected, 'guaranteeSelection', 'vacationRefund']).setValue('');
    formData.get([this.insureSelected, 'guaranteeSelection', 'lostOrStolenLuggage']).setValue('');
    formData.get([this.insureSelected, 'guaranteeSelection', 'deathAndDisability']).setValue('');
    formData.get([this.insureSelected, 'guaranteeSelection', 'tripCancellation']).setValue('');
  }

  /**
   * reloadNumber70Utils
   * @param formData formData
   * @param min min
   * @param max max
   */
  reloadNumber70Utils(formData: FormGroup, min?: number, max?: number): void {
    const canBeInsured: any[] = [];
    this.numberOfInsuredChange = false;
    let minV = 0;
    if (min !== undefined) {
      minV = min;
    }
    let maxV = 0;
    if (max !== undefined) {
      maxV = max;
    }
    if (maxV !== 0) {
      for (let index: number = minV; index <= maxV; index++) {
        canBeInsured.push({ name: `${index}`, id: index });
      }
      formData.get([this.insureSelected, 'yearsList']).setValue('');
      formData.get([this.insureSelected, 'yearsList']).setValue(canBeInsured);
    }
  }

  /**
   * reloadNumberOfInsurablesUtils
   * @param formData formData
   * @param formConfig formConfig
   * @param min min
   * @param max max
   */
  reloadNumberOfInsurablesUtils(formData: FormGroup, formConfig: any, min?: number, max?: number): void {
    const canBeInsured: any[] = [];
    let minV: number = Numbers.number0;
    if (min !== undefined) {
      minV = min;
    }
    let maxV: number = Numbers.number0;
    if (max !== undefined) {
      maxV = max;
    }
    if (minV !== Numbers.number0 && maxV !== Numbers.number0) {
      for (let index: number = minV; index <= maxV; index++) {
        canBeInsured.push({ name: `${index}`, id: index });
      }
      formConfig.numberOfInsured.options.list = canBeInsured;
      formData.get([this.insureSelected, 'numberOfInsuredList']).setValue(canBeInsured);
      this.sportChange = { name: 'sport', value: '' };
      if (formData.get([this.insureSelected, 'numberOfInsured']).value.id <= Numbers.number10 &&
      formData.get([this.insureSelected, 'numberOfInsured']).value.id > Numbers.number1) {
        this.sportChange = { name: 'sport-70', value: formData.get([this.insureSelected, 'insuredsPlayRiskSports']).value };
        this.numInsuredChange = { name: 'num-insured', value: formData.get([this.insureSelected, 'numberOfInsured']).value };
      } else {
        this.sportChange = { name: 'sport-70', value: { name: '' } };
        this.numInsuredChange = { name: 'num-insured', value: { name: '' } };
      }
    } else {
      if (formData.get([this.insureSelected, 'guaranteeLimitOfMedicalExpenses']).value !== '' &&
          this.formDataValue.guaranteeLimitOfMedicalExpenses) {
        for (let index: number = Numbers.number1; index <= this.formDataValue.guaranteeLimitOfMedicalExpenses.numMaxAsegurados; index++) {
          canBeInsured.push({ name: `${index}`, id: index });
        }
        formData.get([this.insureSelected, 'numberOfInsuredList']).setValue(canBeInsured);
      } else {
        for (let index: number = Numbers.number1; index <= Numbers.number100; index++) {
          canBeInsured.push({ name: `${index}`, id: index });
        }
        formData.get([this.insureSelected, 'numberOfInsuredList']).setValue(canBeInsured);
      }
    }
}

  /**
   * validDatesUtils
   * @param formData formData
   */
  validDatesUtils(formData: FormGroup): void {
    if (this.formDataValue.dateStart !== '' && this.formDataValue.dateEnd !== '' &&
        formData.get([this.insureSelected, 'insuranceTime']).value < Numbers.number3) {
      this.showModalDialog3();
      formData.get([this.insureSelected, 'currentlyTraveling']).setValue(false);
    }
  }

  /**
   * getHasCodeDerogationUtils
   * @param formConfig formConfig
   * @param formData formData
   */
  getHasCodeDerogationUtils(formConfig: any, formData: FormGroup): void {
    this.requireChangeV = false;
    if (formData.get([this.insureSelected, 'hasCodeDerogation']).value === true) {
      this.requireChangeV = true;
    }
    if (formData.get([this.insureSelected, 'hasCodeDerogation']).value) {
      formData.get(formConfig.derogationCodes.linkFormPath).setValidators([Validators.required]);
      formData.get(formConfig.derogationCodes.linkFormPath).updateValueAndValidity();
    } else {
      formData.get(formConfig.derogationCodes.linkFormPath).clearValidators();
      formData.get(formConfig.derogationCodes.linkFormPath).updateValueAndValidity();
    }
  }

  /**
   * getDateUtils
   * @param formData formData
   */
  getDateUtils(formData: FormGroup): void {
    if (formData.get([ this.insureSelected, 'currentlyTraveling']).value) {
      this.validDatesUtils(formData);
    }
  }

  /**
   * setValidateAndValueUtils
   * @param formData formData
   */
  setValidateAndValueUtils(formData: FormGroup): void {
    formData.get([this.insureSelected, 'typeStudent']).setValue('');
    if (this.isOriginDestinySpain) {
      formData.get([this.insureSelected, 'countryDestiny']).setValidators([Validators.required]);
      formData.get([this.insureSelected, 'countryDestiny']).updateValueAndValidity();
      formData.get([this.insureSelected, 'countryDestinyI']).clearValidators();
      formData.get([this.insureSelected, 'countryDestinyI']).updateValueAndValidity();
      formData.get([this.insureSelected, 'typeStudent']).setValue('nacional');
    } else if (formData.get([this.insureSelected, 'countryOriginEnvironment']).value === Numbers.number19001) {
      formData.get([this.insureSelected, 'countryDestiny']).setValidators([Validators.required]);
      formData.get([this.insureSelected, 'countryDestiny']).updateValueAndValidity();
      formData.get([this.insureSelected, 'countryDestinyI']).clearValidators();
      formData.get([this.insureSelected, 'countryDestinyI']).updateValueAndValidity();
      formData.get([this.insureSelected, 'typeStudent']).setValue('Outgoing');
    } else {
      formData.get([this.insureSelected, 'countryDestinyI']).setValidators([Validators.required]);
      formData.get([this.insureSelected, 'countryDestinyI']).updateValueAndValidity();
      formData.get([this.insureSelected, 'countryDestiny']).clearValidators();
      formData.get([this.insureSelected, 'countryDestiny']).updateValueAndValidity();
      formData.get([this.insureSelected, 'typeStudent']).setValue('Incoming');
    }
  }

  /**
   * initObsUtils
   * @param formData formData
   */
  initObsUtils(formData: FormGroup): void {
    this.formDataValue = formData.get(this.insureSelected).value;
    setTimeout(() => {
      this.isInvalid = true;
      if (this.formDataValue.numberOfInsured && !this.formDataValue.numberOfInsured.id) {
        formData.get([this.insureSelected, 'numberOfInsured']).setValue('');
      }
      if (formData.get(this.insureSelected).valid) {
        this.isInvalid = false;
      }
    }, Numbers.number100);
  }

  /**
   * loadVars
   * @param currentStep number
   * @param linkFormPath string
   * @param numberOfInsured any
   * @param insuredOlderThan60years any
   * @param allInsuredSameFamiliarUnit boolean
   */
  loadVars(currentStep: number, linkFormPath: string, numberOfInsured: any, insuredOlderThan60years: any,
           allInsuredSameFamiliarUnit: boolean): void {
    this.currentStep = currentStep;
    this.insureSelected = linkFormPath;
    this.numberOfInsuredList = numberOfInsured;
    this.yearsList = insuredOlderThan60years;
    this.unitfamiliar = allInsuredSameFamiliarUnit;
  }

  /**
   * changeCountry
   * @param country SelectMultipleValueModel
   * @param formConfig any
   * @param formData FormGroup
   */
  changeCountry(country: SelectMultipleValueModel, formConfig: any, formData: FormGroup): void {
    this.countryDChange = { name: 'countryRisk', value: country };
    if (country.name === 'España') {
      this.isOriginDestinySpain = true;
    } else {
      this.isOriginDestinySpain = false;
    }
    this.getLisIniGuaranteeLimitOfMedicalExpensesUtils(formConfig, formData);
  }

  /**
   * showStepFields
   */
    showStepFields(formData: FormGroup): void {
      this.setValidateAndValueUtils(formData);
      this.showStep1Fields = false;
      if (formData.get([this.insureSelected, 'countryOriginEnvironment']).value !== '' &&
          formData.get([this.insureSelected, 'countryDestinyEnvironment']).value !== '') {
        this.showStep1Fields = true;
      }
    }

  /**
   * downloadFileService
   * @param id id
   */
  downloadFileService(id: any, documentService: DocumentsService): void {
    if (id > 0) {
      documentService.getAditinalDocument(id, this.documentsConst.idProveedor, this.documentsConst.idPortal,
        this.documentsConst.productGeneral).pipe(take(1)).subscribe((res) => {
          this.downloadFile(res, this.documentsConst.generalName);
        });
    }
  }
}
